/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ portals: NonNullable<unknown> }} Property_Archive_Confirm_With_PortalsInputs */

const cs_property_archive_confirm_with_portals = /** @type {(inputs: Property_Archive_Confirm_With_PortalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archivovat tuto nemovitost? Skryje se na webu a odebere z portálů: ${i?.portals}.`)
};

const en_property_archive_confirm_with_portals = /** @type {(inputs: Property_Archive_Confirm_With_PortalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archive this property? It will be hidden on the website and removed from portals: ${i?.portals}.`)
};

/**
* | output |
* | --- |
* | "Archive this property? It will be hidden on the website and removed from portals: {portals}." |
*
* @param {Property_Archive_Confirm_With_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_archive_confirm_with_portals = /** @type {((inputs: Property_Archive_Confirm_With_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Archive_Confirm_With_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_archive_confirm_with_portals(inputs)
	return cs_property_archive_confirm_with_portals(inputs)
});